import React from 'react';


function ClipModalInfo(props) {
    return (
      <div className="flex items-center">
        <img
          className="w-8 h-8 rounded-full"
          src={props.pfp}
        />
        <div className="text-white font-semibold ml-2">
          {props.username}
        </div>
      </div>
    );
}

export default ClipModalInfo;
